import {
  AfterViewInit,
  Component,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { DialogData } from 'dg-emp-search-lib';
import { FolderService } from '../folder/folder.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { FolderComponent } from '../folder/folder.component';
import { Folder } from 'src/app/digigov/models/folder.model';
import { SelectCaseDialogComponent } from '../actions/selectCaseDialog/select-case-dialog.component';
import { DatatableComponent } from '@swimlane/ngx-datatable';

@Component({
  selector: 'moveToFolder',
  templateUrl: './moveToFolder.component.html',
  styleUrls: ['./moveToFolder.component.scss'],
})
export class MoveToFolderComponent implements OnInit {
  output: any;
  rowIndex = null;
  folder: Folder = {
    folderName: null,
    folderDesc: null,
    prntFolderName: '',
    folderId: -1,
    prntFolderId: -1,
  };
  data = [];
  events = [
    { label: 'worklist', value: 'worklist' },
    { label: 'dashboard', value: 'dashboard' },
    { label: 'reports', value: 'reports' },
  ];
  selected = [];
  moveFolder = {
    tokenId: null,
    appTypeId: 1,
    folderIdArr: null,
    fromFolderFlag: 0,
  };
  folderId: any;
  @ViewChild('table') table: DatatableComponent;
  rows = [];
  isEditable = {};
  filteredList: any;
  sData: any;

  constructor(
    private service: FolderService,
    private http: HttpClient,
    private dialogRef: MatDialogRef<MoveToFolderComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public caseData: DialogData
  ) {
    this.sData = this.caseData;
  }

  ngOnInit(): void {
    this.fetchData();
    this.rows = this.data;
    this.rows.forEach((row) => {
      const testArr = [];
      row.selected = row.application;
    });
    this.filteredList = this.rows;
  }

  fetchData(): void {
    if (!this.sData.personalFolder) {
      let params = new HttpParams();
      params = params.append('folderId', '0');
      params = params.append('fromFolderflag', '0');
      this.http
        .get('/case-mgmnt/user-folders', { params: params })
        .subscribe((res) => {
          const restemp: any = res;
          this.filteredList = restemp.data;
          this.rows = restemp.data;
        });
    } else {
      let params = new HttpParams();
      params = params.append('folderId', this.sData.personalFolder);
      params = params.append('fromFolderflag', '1');
      this.http
        .get('/case-mgmnt/user-folders', { params: params })
        .subscribe((res) => {
          const restemp: any = res;
          this.filteredList = restemp.data;
          this.rows = restemp.data;
        });
    }
  }
  // Open/close panel
  toggleExpandRow(row, expanded): void {
    this.table.rowDetail.toggleExpandRow(row);
    if (!expanded) {
      this.table.rowDetail.collapseAllRows();
      this.table.rowDetail.toggleExpandRow(row);
    } else if (expanded) {
      this.table.rowDetail.collapseAllRows();
    }
  }

  // Save row
  save(row, rowIndex): void {
    this.folder.folderName = row.folderName;
    this.folder.folderDesc = row.folderDesc;
    this.folder.folderId = row.folderId;
    this.service.editFolder(this.folder).subscribe(() => {
      this.isEditable[rowIndex] = !this.isEditable[rowIndex];
    });
  }

  // Delete row
  delete(row, rowIndex): void {
    this.service.deleteFolder([row]).subscribe(() => {
      this.filteredList = [...this.filteredList];
      this.fetchData();
    });
  }

  updateFilter(filterValue: string): void {
    const lowerValue = filterValue.toLowerCase();
    this.filteredList = this.rows.filter(
      (item) =>
        item.folderName.toLowerCase().indexOf(lowerValue) !== -1 || !lowerValue
    );
  }
  create(): void {
    const createdialogRef = this.dialog.open(FolderComponent, {
      width: '600px',
    });
    createdialogRef.afterClosed().subscribe(() => {
      this.fetchData();
    });
  }
  getData(row, rowIndex): void {
    this.output = row;
    this.folderId = row.folderId;
    this.moveFolder.folderIdArr = this.folderId;
  }
  move(): void {
    this.sData = this.caseData;
    this.moveFolder.appTypeId = this.sData.applTypeId
      ? this.sData.applTypeId
      : this.sData.data[0].appTypeId;
    this.moveFolder.tokenId = Number(this.sData.selectedData[0].docId);
    const folderArr = [];
    const errorMsg = 'Select a folder.';
    folderArr.push(this.folderId);
    this.moveFolder.folderIdArr = folderArr;
    if (!this.folderId || this.folderId === 0) {
      this.dialog.open(SelectCaseDialogComponent, { data: errorMsg });
    } else {
      if (this.sData.personalFolder) {
        this.moveFolder.fromFolderFlag = 1;
        this.http
          .post('/case-mgmnt/move-to-folder', this.moveFolder)
          .subscribe((res) => {
            this.dialogRef.close(true);
          });
      } else {
        this.http
          .post('/case-mgmnt/move-to-folder', this.moveFolder)
          .subscribe((res) => {
            this.dialogRef.close(true);
          });
      }
    }
  }

  cancel(row, rowIndex) {
    this.isEditable[rowIndex] = !this.isEditable[rowIndex];
    this.filteredList = [...this.filteredList];
  }
}
